import React, { Component } from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { InfoLabel, Icon, Loader } from '@jutro/components';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
//import { SelectProducerCode } from 'gw-gateway-common-react';
import { PolicyService } from 'gw-capability-policy';
import { GatewayPolicyService, UserService } from 'gw-capability-ri-policy';
import { withAuthenticationContext} from 'gw-digital-auth-react';
import { TranslatorContext } from '@jutro/locale';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { isCapabilityEnabled } from 'gw-portals-config-js';
import { DependencyProvider } from 'gw-portals-dependency-react';
import { PolicyBilling }  from 'gw-capability-ri-policy-react';
import { UsersProfile } from 'gw-capability-profileinfo-react';
import { MyPolicy, UserManager, ManageRIUsers } from 'gw-capability-ri-policy-admin-react';

// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import CommonRoutes from '../../Common/CommonRouting';
import pageRouting from '../../Common/Admin-config.json5';
import styles from './AdminLanding.module.scss';
import metadata from './AdminLanding.metadata.json5';
import messages from '../../Admins.messages';

const { capabilitiesConfig } = appConfig;

const DocumentPageService = {
};

class AdminLanding extends Component {
    static contextType = TranslatorContext;
    static propTypes = {
        match: PropTypes.shape({
            path: PropTypes.string,
            url: PropTypes.string
        }).isRequired,
        authHeader: PropTypes.shape({}).isRequired,
        authUserData: PropTypes.object.isRequired,
        isLoggedIn: PropTypes.bool,
        location: PropTypes.shape({
            state: PropTypes.string,
            pathname: PropTypes.string
        }).isRequired        
    };

    state = {
        currentView: undefined,
        isLoading: true,
        selectedProducerCode: 'all',
        selectedHeaderContent: messages.recentlyViewed,
        policyResponse: {},
        policyBillingData: {}
   };

    componentDidMount() {
        this.setState({
            currentView: 'usermanager',
        });
        this.getBillingDetails();
    }

    getRoutesWithFeature() {
        const routes = [...pageRouting];
        this.userProfileActive(routes);

        //this.billingFeatureTurnedOn(routes);
        this.myUsersActive(routes);
        this.myPolicyActive(routes);
        this.riManageRIUsers(routes);

        // documentFeatureTurnedOn(routes);
        // console.log("Routes ", routes);
        return routes;
    }

    userProfileActive = (routes) => {
        if (isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'policy' }) ) {
            const iaRoute = {
                path: '/account',
                component: UsersProfile
            };
            routes.push(iaRoute);
        }
    };

    myPolicyActive = (routes) => {

        if (isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'policy' }) && this.isRIUser()) {
            const mypolicyRoute = {
                path: '/mypolicy',
                component: MyPolicy
            };
            routes.push(mypolicyRoute);
        }
    };

    myUsersActive = (routes) => {

        if (isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'policy' }) && this.isUserManager()) {
            const myUserRoute = {
                path: '/usermanager',
                component: UserManager
            };
            routes.push(myUserRoute);
        }
    };
    
    // FB 17118
    riManageRIUsers = (routes) => {
        if (isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'policy' })) {

            const manageRIUserRoute = {
                path: '/riManageRIUsers',
                component: ManageRIUsers
            };
            routes.push(manageRIUserRoute);
        }
    };

    isRIUser() {
        const { authUserData } = this.props;
        if (_.isUndefined(authUserData)) { return false }
        const userId = authUserData.userID;
        const isAdmin = authUserData.isWebAdmin;
        if (!(_.isEmpty(userId)) && isAdmin) {
            return true;
        } else {
            return false;
        }
    }

    isUserManager() {
        const { authUserData } = this.props;
        if (_.isUndefined(authUserData)) { return false }
        return authUserData.isUserManager;
    }
    // FB 17118
    isMarketingUser() {
        const { authUserData } = this.props;
        
        if (_.isUndefined(authUserData) || _.isUndefined(authUserData.isMarketingUser)) {
             return false 
        }     

        return authUserData.isMarketingUser;
    }

    getBillingDetails = async () => {
        const {
            isLoggedIn,
            authHeader,
            authUserData,
            match: {
                params: { policyNumber }
            },
            location: { state: redirectPath, pathname }
        } = this.props;
        /* Get policy Summaries */

        var defaultPolicy = policyNumber;
   //     if (_.isEmpty(policyNumber)) {
            await await PolicyService.getAccountPolicySummaries(authHeader).then(
                (getPolicyResponse = {}) => {
                    if (!_.isUndefined(getPolicyResponse) && !(Object.keys(getPolicyResponse).length === 0)) {
                        const routePath = pathname && (pathname.trim().split('/') || []);
                        const selectedPageFromPath = routePath[routePath.length - 1];
                        const activeTile = selectedPageFromPath || redirectPath || 'usermanager';
                        defaultPolicy = _.get(getPolicyResponse[0].periods, '[0].policyId')
                        getPolicyResponse.numberOfDocuments=0;     
                        if (!_.isUndefined(authUserData) && authUserData.isWebAdmin) {
                            this.setState({
                                currentView: 'mypolicy',
                                policyResponse: getPolicyResponse
                            });
                            return this.props.history.push("/ri-admin/"+defaultPolicy+"/mypolicy");
                        }
                        if (_.isEmpty(policyNumber)) {
                            this.setState({
                                currentView: activeTile,
                                policyResponse: getPolicyResponse
                            });
                            defaultPolicy = _.get(getPolicyResponse[0].periods, '[0].policyId')
                            return this.props.history.push("/ri-admin/"+defaultPolicy+"/usermanager");
                        }                
                        this.setState({
                            currentView: activeTile,
                            policyResponse: getPolicyResponse
                    });
                    } 
                }
            );     
     //   }
        await GatewayPolicyService.getPolicyBillingSummaryInfo(defaultPolicy, authHeader).then(
            (billingResponseData = {}) => {
                if (!_.isUndefined(billingResponseData.policyPeriodBillingSummaries)) {
                    const billingData = billingResponseData.policyPeriodBillingSummaries;
                    const billingIcon = _.get(billingData, '[0].isDelinquent')
                        ? 'mi-warning'
                        : 'mi-payment';
                    this.setState({
                        policyBillingData: billingResponseData,
                        billingIcon: billingIcon
                    });
                } else {
                    const billingIcon = 'mi-payment';
                    this.setState({
                        billingIcon: billingIcon
                    });
                }
            }
        );
        this.setState({
            isLoading: false
        });        
        
    };

    handleTilesOnClick = (id) => {
        this.setState({ currentView: id });
    };    


    getCell = (item, index, { id: property }) => {
        const translator = this.context;
        const toolTipMessage = {
            product: translator(messages.product),
            dateOfLoss: translator(messages.dateOfLoss),
            status: translator(messages.status)
        };

        return (
            <span title={toolTipMessage[property]}>
                {item[property]}
            </span>
        );
    };

    getCurrencyCell = (item, index, { id: property }) => {
        const translator = this.context;
        const toolTipMessage = {
            paid: translator(messages.totalPayments),
            netIncurred: translator(messages.totalIncurrednet)
        };
        return (
            <span title={toolTipMessage[property]}>
                <CurrencyField
                    id={`claimsCurrency_${index}`}
                    value={item[property]}
                    datatype="object"
                    readOnly
                    hideLabel
                />
            </span>
        );
    };

    handleOnClick = (id) => {
        this.setState({ currentView: id });
    };

    handleValueChange = (producerCode) => {
        this.setState({
            selectedProducerCode: producerCode
        });
    };

    getLink = (item, index, { id: property }) => {
        const translator = this.context;
        let toolTipMessage = translator(messages.claimNumber);
        if (property === 'policyNumber') {
            toolTipMessage = translator(messages.policyNumber);
            return (
                <Link
                    to={`/policies/${item[property]}/summary`}
                    className={styles.gwClaimsLinkContent}
                    title={toolTipMessage}
                >
                    {item[property]}
                </Link>
            );
        }
        return (
            <Link to={redirectpath} className={styles.gwClaimsLinkContent} title={toolTipMessage}>
                {item[property]}
            </Link>
        );
    };

    getAdminHeader = (policyBillingData) => {
        if (_.isEmpty(policyBillingData)) {
            return null;
        }
        const acctStatus = _.get(policyBillingData.policyPeriodBillingSummaries, '[0].accountStatus_Ext');
//        const billingNo = `(${policyBillingData.policyPeriodBillingSummaries[0].billingAccountNumber_Ext})`;
        const billingNo = ``;
        return (
            <>
                 <div className={styles.gwTypeWithLOB}>
                    <Icon icon="mi-settings_applications" className={styles.syncIcon} />
                    <h1 className={styles.gwPageTitle}>{messages.adminTitle.defaultMessage} {billingNo}</h1>
                </div>
            </>
        );
    };

    render() {
        const {
            policyResponse,
            currentView,
            isLoading,
            billingIcon,
            policyBillingData
        } = this.state;
        if (isLoading) {
            return <Loader loaded={!isLoading} />;
        }
        
        if (_.isEmpty(policyResponse)) {
            return null;
        }
        const overrides = {
            [currentView]: {
                active: true
            },
            tabBillingSummaryTitle: {
                content: this.getAdminHeader(policyBillingData)
            },  
            mypolicy: {
                active: currentView === 'mypolicy',
                visible: this.isRIUser()
            },
            usermanager: {
                active: currentView === 'usermanager',
                visible: this.isUserManager()
            },
            // FB 17118
            riManageRIUsers: {
                active: currentView === 'riManageRIUsers',
                visible: false //this.isUserManager() && this.isMarketingUser()
            }
        };

        const resolvers = {
            resolveComponentMap: {},
            resolveCallbackMap: {
                handleTilesOnClick: this.handleTilesOnClick
            },
            resolveClassNameMap: styles
        };
        const {
            match: { url }
        } = this.props;
        const policyDetailsData = {
            policyResponse: policyResponse
        };
        return (
             <DependencyProvider value={{ DocumentPageService }}>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={policyResponse}
                    overrideProps={overrides}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                    classNameMap={resolvers.resolveClassNameMap}
                />
                 <CommonRoutes
                    steps={this.getRoutesWithFeature()}
                    basePath={url}
                    setDocumentCount={this.updateDocumentCount}
                    policyNumber={policyResponse.policyNumber}
                    policyDetailsData={policyDetailsData}
                    billingData={policyBillingData}
                /> 
            </DependencyProvider> 
        );
    }
}

export default withRouter(withAuthenticationContext(AdminLanding));
